type Props = {
  status: TournamentStatus;
  theme: Theme;
  won?: boolean;
};

const getTournamentColor = ({ status = 'past', theme, won }: Props) => {
  switch (status) {
    case 'current':
      return theme.color.roshi[100];
    case 'future':
      return theme.color.piccolo[100];
    case 'past':
      return won ? theme.color.krillin[100] : theme.color.trunks[100];
    default:
      return theme.color.trunks[100];
  }
};

export default getTournamentColor;
